import { AnimatePresence, motion } from 'framer-motion';
import { useGetParams } from './hooks/useGetParams';
import { useBroadcast } from './hooks/useBroadcast';

import { Table } from './components/Table/Table';

import posterDefault from './assets/images/poster.png';
import bgDefaultVideo from './assets/video/bgVideo.mp4';

import logo from './assets/images/logo.png';

function App() {
  const { isVisible, messages } = useBroadcast();
  const {
    cols,
    rows,
    bgVideo,
    bgPoster,
    scaleMsg,
    title,
    titleFontSize,
    msgFontSize,
    animRotateDuration,
    animMovementDelay,
    animMovementDuration,
    animGlareDuration,
  } = useGetParams();

  return (
    <div className="app-wrapper">
      <div className="title" style={{ fontSize: `${titleFontSize}rem` }}>
        {title}
      </div>

      <AnimatePresence mode="wait">
        {isVisible && (
          <motion.div
            key="table"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}>
            <Table
              rows={rows}
              cols={cols}
              messages={messages}
              scaleMsg={scaleMsg}
              msgFontSize={msgFontSize}
              animRotateDuration={animRotateDuration}
              animMovementDelay={animMovementDelay}
              animMovementDuration={animMovementDuration}
              animGlareDuration={animGlareDuration}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <img src={logo} className="logo" alt="logo" />

      {bgVideo && (
        <motion.video
          key="bgMain"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.5,
          }}
          autoPlay="autoplay"
          muted="muted"
          loop
          id="bgVideo"
          poster={bgVideo === '1' ? posterDefault : bgPoster}>
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/mp4"></source>
        </motion.video>
      )}

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
